module.exports = __webpack_public_path__ + "2265a0e7f42246660346b8e445065e94.png";